import React, { useCallback } from 'react';
import analytics from '@sy/app-client/src/ssrAdapter/services/analytics';
import { events } from '~/services/tracking';
import { StyledAnchor } from './Anchor.styles';

const createValidHref = (href: string): string => {
	try {
		return new URL(href).href;
	} catch {
		return href.startsWith('/') ? href : `https://${href}`;
	}
};

const Anchor = ({ href, ...props }: { href: string }) => {
	const trackAnchorClick = useCallback(() => {
		analytics.track(events.MAIN_CONTENT_INTERACTION_CLICKED, {
			contentType: 'link',
			destinationUrl: href,
		});
	}, [href]);

	return (
		<StyledAnchor
			{...props}
			href={createValidHref(href as string)}
			onClick={trackAnchorClick}
		/>
	);
};

export default Anchor;
